import request from '@/api/request'

export default {
  async getAttributes (categoryCode) {
    return (await request.get(`module/action/marketplace/leroy/category/attributes/${categoryCode}`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/leroy/index.js